'use strict';

export let DescargasRouteComponent = {
    selector: 'descargasRoute',
    template: require('./descargas-route.html'),
    bindings: {
        descargas: '<'
    }
};



// WEBPACK FOOTER //
// ./client/app/descargas-route/descargas-route.component.js